import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const BackedBySection = () => {
  return (
    <CMSRender
      contentType="PWUCollaborate"
      match={{ "content.title": "Backed by Global Leading Publishers" }}
      renderItem={(data, id) => {
        return (
          <div className="w-full flex flex-col gap-[67px] px-[16px] md:px-px1_l xl:px-px1_xl lg:mb-[34px]">
            {/* Colored Container */}
            <div
              key={id}
              className="w-full lg:max-w-w1_xl bg-gradient_pwu_collaborate rounded-[50px] md:rounded-[70px] px-[32px] lg:px-[60px] xl:px-[120px] py-[58px] mx-auto"
            >
              <div className="mx-auto">
                {/* Title - Centered */}
                <Typography
                  variant="h2"
                  className="text-text text-center mb-[65px]"
                >
                  {data.title}
                </Typography>

                {/* Logo Row - Evenly spaced */}
                <div className="w-full max-w-[264px] md:max-w-[600px] lg:max-w-[1100px] flex flex-wrap items-center justify-center lg:justify-between gap-x-[70px] lg:gap-x-0 gap-y-[40px] lg:gap-y-0 mx-auto">
                  {data.logos.map((logo, index) => (
                    <img
                      key={index}
                      src={logo}
                      alt={`Partner logo ${index + 1}`}
                      className="w-auto object-contain"
                    />
                  ))}
                </div>

                {/* Description */}
                <Typography
                  variant="body1"
                  className="max-w-[960px] text-center mx-auto mt-[65px]"
                >
                  {data.description}
                </Typography>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default BackedBySection
